import * as React from 'react';
import classnames from 'classnames';
import styles from './printedTableComponents.module.css';
export const PrintedTableHeader = ({ children }) => (React.createElement("div", { className: styles.TableHeader }, children));
export const PrintedTableRow = ({ children, classes, }) => React.createElement("div", { className: classnames(styles.TableRow, classes) }, children);
export const PrintedTableFooter = ({ children }) => (React.createElement("div", { className: styles.TableFooter }, children));
export const PrintedTableSpacer = () => (React.createElement("div", { className: styles.TableSpacer }));
export const PrintedTableHorizontalBorder = () => (React.createElement("div", { className: styles.TableHorizontalBorder }));
